<div class="d-flex">
  <dx-button
    text="{{ 'ADD_COMMENT' | translate }}"
    icon="mdi mdi-plus"
    class="btn mb-2"
    (onClick)="addAction()"
    [disabled]="!order?.id"></dx-button>
</div>

<dx-data-grid
  [dataSource]="acts$ | async"
  keyExpr="id"
  [allowColumnReordering]="true"
  [showBorders]="true"
  class="data-grid-responsive mb-2"
  rowTemplate="rowTemplateName">
  <dxi-column dataField="id" caption="Id" sortOrder="asc" [visible]="false"></dxi-column>
  <dxi-column dataField="typeName" caption="{{ 'TYPE' | translate }}"></dxi-column>
  <dxi-column dataField="date" caption="{{ 'DATE_TIME' | translate }}" [width]="180"></dxi-column>
  <dxi-column dataField="employee.fio" caption="{{ 'USER' | translate }}"></dxi-column>
  <dxi-column dataField="description" caption="{{ 'DESCRIPTION' | translate }}"></dxi-column>
  <dxi-column dataField="status.name" caption="{{ 'STATUS' | translate }}"></dxi-column>
  <dxi-column dataField="adminStructure.value" caption="{{ 'ROS' | translate }}"></dxi-column>
  <dxi-column dataField="coordinator?.fio" caption="{{ 'COORDINATOR' | translate }}"></dxi-column>
  <dxi-column dataField="message" caption="{{ 'MESSAGE' | translate }}" [width]="110"></dxi-column>
  <dxi-column dataField="mark" caption="{{ 'MARK' | translate }}" [width]="80"></dxi-column>

  <tbody class="dx-row" *dxTemplate="let act of 'rowTemplateName'">
    <tr class="main-row dx-row-lines dx-column-lines">
      <td>
        <label style="display: none">{{ 'TYPE' | translate }}</label>
        {{ act.data.typeName }}
      </td>
      <td>
        <label style="display: none">{{ 'DATE_TIME' | translate }}</label>
        {{ act.data.date | date: 'dd-MM-yyyy HH:mm:ss' }}
      </td>
      <td>
        <label style="display: none">{{ 'USER' | translate }}</label>
        {{ act.data.employee?.fio }}
      </td>
      <td>
        <label style="display: none">{{ 'DESCRIPTION' | translate }}</label>
        {{ act.data.description }}
      </td>
      <td>
        <label style="display: none">{{ 'STATUS' | translate }}</label>
        {{ act.data.status.name }}
      </td>
      <td>
        <label style="display: none">{{ 'ROS' | translate }}</label>
        {{ act.data.adminStructure?.value }}
      </td>
      <td>
        <label style="display: none">{{ 'COORDINATOR' | translate }}</label>
        {{ act.data.coordinator?.fio }}
      </td>
      <td style="text-align: center">
        <label style="display: none">{{ 'MESSAGE' | translate }}</label>
        @if (act.data.message === true) {
          <span><i class="mdi mdi-check mdi-18px"></i></span>
        }
      </td>
      <td style="text-align: center">
        <label style="display: none">{{ 'MARK' | translate }}</label>
        {{ act.data.mark }}
      </td>
    </tr>
  </tbody>
</dx-data-grid>

<app-dialog-edit-text></app-dialog-edit-text>
